<nz-modal
  nzWrapClassName="form-modal"
  [(nzVisible)]="isVisibleModal"
  [nzTitle]="modalTitle"
  [nzCentered]="true"
  [nzClassName]="'modal-m-t-30'"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  [nzMaskStyle]="{'background': 'rgba(255, 255, 255, 0.69)'}"
  (nzOnCancel)="onEmitCloseModal(false)"></nz-modal>

<ng-template #modalTitle>
  <div class="container-steps-modal" [@fadeInAnimation]>
    <h2 class="text-title-md-bold title-modal">Nueva nota</h2>
    <p class="text-info mt-xxs">{{ messageCreateNote || 'Se agregará una nueva nota' }}</p>
  </div>
</ng-template>

<ng-template #modalContent>
  <div class="editor-section">
    <div class="NgxEditor__Wrapper">
      <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"> </ngx-editor-menu>
      <ngx-editor
        [editor]="editor"
        [(ngModel)]="note"
        [disabled]="false"
        [placeholder]="'Nota...'"></ngx-editor>
    </div>
    <div class="mt-xlg d-flex align-items-center">
      <span class="text-subtitle-bold mr-sm">Compartir nota con el paciente</span>
      <nz-switch class="success-tint" [(ngModel)]="shareNote"></nz-switch>
    </div>
  </div>
</ng-template>

<ng-template #modalFooter>
  <div class="container-footer-modal" [@fadeInAnimation]>
    <button
      style="margin-right: 5px;"
      (click)="onEmitCloseModal(false)"
      nz-button nzType="cancel">
      <i nz-icon nzType="close-circle" nzTheme="outline"></i>
      CANCELAR</button>
    <button
      (click)="onEmitCloseModal(true)"
      nz-button nzType="primary">
      <i nz-icon nzType="save" nzTheme="outline"></i>
      GUARDAR NUEVA NOTA</button>
  </div>
</ng-template>
